import AdminsApiV2 from 'api/v2/admins-api-v2.js'
import InputField from 'components/molecules/input-field'
import PublicHeader from 'components/organisms/public-header'
import PublicPageTemplate from 'components/templates/public-page-template'
import { Form, Formik } from 'formik'
import { useAuth } from 'providers/auth-provider'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router'
import { Button, Card, CardBody } from 'reactstrap'
import loginSchema from './login-schema'
import { LOCAL_STORAGE_JWT_TOKEN } from 'domains/admin/constants'

const LoginPage = () => {
  useEffect(() => {
    return () => {
      document.body.classList.remove('bg-default')
    }
  }, [])

  const authContext = useAuth()
  const history     = useHistory()

  useEffect(() => {
    if (authContext.isAuth) history.push('/app')
  }, [authContext.isAuth, history])

  const handleSubmit = async (values, actions) => {
    try {
      const response = await AdminsApiV2.login(values.email, values.password)
      if (response?.data?.token) {
        localStorage.setItem(LOCAL_STORAGE_JWT_TOKEN, response.data.token)
      }
      const admin = response.data.admin

      authContext.onLogin({
        name : `${admin.first_name} ${admin.last_name}`,
        role : admin.access
      })
    } catch (error) {
      actions.setSubmitting(false)
      alert(error.response?.data?.error || error.message)
    }
  }

  return (
    <PublicPageTemplate
      header={<PublicHeader title='Belle and Kate' lead='Dashboard'/>}
    >
      <Card className="bg-secondary border-0 mb-0">
        <CardBody className="px-lg-5 py-lg-5">
          <Formik
            initialValues={{ email: '', password: '' }}
            validationSchema={loginSchema}
            onSubmit={handleSubmit}
          >
            {(formikProps) => (
              <Form>
                <InputField
                  type='email'
                  name='email'
                  placeholder='Email'
                />
                <InputField
                  type='password'
                  name='password'
                  placeholder='Password'
                />
                <Button
                  block
                  color='success'
                  type='submit'
                  disabled={formikProps.isSubmitting}
                >
                  Login
                </Button>
              </Form>
            )}
          </Formik>
        </CardBody>
      </Card>
    </PublicPageTemplate>
  )
}

export default LoginPage
